import { render, staticRenderFns } from "./plan_and_package.vue?vue&type=template&id=627b6b61&scoped=true"
import script from "./plan_and_package.vue?vue&type=script&lang=js"
export * from "./plan_and_package.vue?vue&type=script&lang=js"
import style0 from "./plan_and_package.vue?vue&type=style&index=0&id=627b6b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b6b61",
  null
  
)

export default component.exports